import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export const keys = createQueryKeySet<UseRefereeLicensesListQueryParams>('referee-licenses');

type UseRefereeLicensesListQueryParams = Parameters<typeof SSF.api.judgeLicensesList>[0];

export function useRefereeLicensesListQuery(params: UseRefereeLicensesListQueryParams = {}, enabled = true) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.judgeLicensesList(params);
      return data;
    },
    queryKey: keys.list(params),
    enabled,
  });
}

export function useRefereeLicenseQuery(id: number) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.judgeLicensesRetrieve(id);
      return data;
    },
    queryKey: keys.detail(id),
  });
}
